import VerticalPointerLine from './VerticalPointerLine';

export default VerticalPointerLine;
